<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import PageBreadcrumb from '@/components/common/PageBreadcrumb.vue'
import CompanyTable from '../components/CompanyTable.vue'

export default defineComponent({
  name: 'company-list',
  data() {
    return {
      searchTerm: '',
    }
  },
  components: { CompanyTable, PageBreadcrumb },
})
</script>

<template>
  <main class="flex-1">
    <div class="py-6">
      <div class="max-w-(--breakpoint-2xl) mx-auto">
        <PageBreadcrumb page-title="Zoznam spoločností" />
      </div>
      <company-table :hladaj="searchTerm"></company-table>
    </div>
  </main>
</template>
